import { HomeViewRole } from '@app/constants/home';
import { EDUCATOR_ROLE, STUDENT_ROLE } from '@core/constants/space';
import {
  HomeSpaceEngagementApiItem,
  HomeSpaceProgressApiItem,
  HomeSpacesByRoleState,
  HomeSpacesRoleState,
} from '@core/types/state';

export const createEmptyHomeSpacesRoleState = (): HomeSpacesRoleState => ({
  spaces: [],
  cursor: null,
  hasMore: true,
  loading: false,
  error: false,
  errorType: null,
  progressById: {},
  engagementById: {},
  refreshingCardDataSpaceId: null,
});

export const createInitialHomeSpacesByRoleState =
  (): HomeSpacesByRoleState => ({
    [EDUCATOR_ROLE]: createEmptyHomeSpacesRoleState(),
    [STUDENT_ROLE]: createEmptyHomeSpacesRoleState(),
  });

export const isHomeViewRole = (role: string): role is HomeViewRole =>
  role === EDUCATOR_ROLE || role === STUDENT_ROLE;

export const mergeHomeSpacesProgressById = (
  current: Record<string, HomeSpaceProgressApiItem>,
  items: HomeSpaceProgressApiItem[]
) => {
  const next = { ...current };

  items.forEach((item) => {
    next[item.spaceId] = item;
  });

  return next;
};

export const mergeHomeSpacesEngagementById = (
  current: Record<string, HomeSpaceEngagementApiItem>,
  items: HomeSpaceEngagementApiItem[]
) => {
  const next = { ...current };

  items.forEach((item) => {
    next[item.spaceId] = item;
  });

  return next;
};
